import React from 'react';
import { ChannelConnectionProps } from './ChannelConnection';
import { Skeleton } from '@mui/material';
import useChannelEvent from './hooks/useChannelEvent';

import { StatusButton } from '../../Merchandiser/Components/StatusButton';
import { getIcon } from '../../../util/getIcon';
import useCommanderStatus from '../../../../../redux/commander/commander-status/hooks/useCommanderStatus';

function ChannelEvent(props: ChannelConnectionProps) {
  const {
    loading,
    valueString: eventString,
    name: eventName,
  } = useChannelEvent(props);

  const { commanderStatus } = useCommanderStatus(props.channel?.deviceId || '');
  const isOn = commanderStatus?.mqttConnected && commanderStatus?.vpnConnected;

  return (
    <>
      {loading ? (
        <Skeleton variant="text" width={'100%'} component={'span'} />
      ) : (
        <StatusButton
          description={`${eventName} ${eventString}`}
          icon={getIcon(props.channel?.channel ?? '')}
          onClick={props.onClick || (() => {})}
          status={eventString}
          loading={loading}
          isOn={isOn}
        />
      )}
    </>
  );
}

export default ChannelEvent;
